export const validation: Record<
  string,
  {
    validate: (b1: boolean, b2: boolean) => boolean;
    cleanup: (b1: boolean, b2: boolean) => boolean;
  }
> = {
  orthoRequiresThree: {
    validate(orthoIsEnabled, threeIsEnabled) {
      return threeIsEnabled || !orthoIsEnabled;
    },
    cleanup(_, threeIsEnabled) {
      return !threeIsEnabled;
    },
  },
};
